<template>
    <el-dialog
        title="温馨提示"
        :visible="dialogVisible"
        width="560px"
        :center="true"
        top="30vh"
        :close-on-click-modal="false"
        :destroy-on-close="true"
        :before-close="cancelDelete"
    >
        <!-- 提示文字 -->
        <div class="prompt">当前施工单位下有钻探任务，若要删除施工单位，请先删除该施工单位下的钻探任务！</div>
        <!-- 按钮 -->
        <div class="button-div">
            <button @click="cancelDelete" class="confirm">我知道了</button>
        </div>
    </el-dialog>
</template>
<script>
import { DeleteUnitList } from '@/http/api/api-hb'
export default {
    data() {
        return {
            dialogVisible: false,
        }
    },
    methods: {
        showUnitPrompt() {
            this.dialogVisible = true
        },
        cancelDelete() {
            this.dialogVisible = false
        },
    },
}
</script>
<style scoped>
    @import url(../../../assets/css/dialog_button_div.css);
    ::v-deep .el-dialog {
        border-radius: 10px;
    }
    ::v-deep .el-dialog--center .el-dialog__body {
        padding: 0 52px 30px;
        /* background-color: #ff0000; */
    }
    ::v-deep .el-dialog__title {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #181818;
    }
    /* 文字内容 */
    .prompt {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #777777;
        line-height: 25px;
        margin: 24px 0 16px;
    }
    .dialog-content {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #181818;
        line-height: 25px;
        margin-bottom: 16px;
    }
</style>